import type { Table } from '@tanstack/react-table';
import type { HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function TableBulkActionsPanel<T extends Table<any>>({
  table,
  children,
  className = '',
  ...props
}: HTMLAttributes<HTMLDivElement> & {
  table: T;
}) {
  const { getSelectedRowModel } = table;

  if (getSelectedRowModel().rows.length === 0) {
    return null;
  }

  return (
    <div
      data-theme="dark-neutral"
      data-cy="table-bulk-actions-panel"
      className={twMerge(
        'rounded-sm sticky bottom-16 left-0 flex h-64 w-full animate-fade-in-up-short items-center justify-center overflow-hidden border border-paper-4 bg-paper-6',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
